































import _ from 'lodash'
import { Component, Watch } from 'vue-property-decorator'
import BaseInput from '@/services/BaseInput'

@Component
export default class Radio extends BaseInput {
  public selected = typeof this.value === 'number'
    ? (_.toString(this.value) === '' ? 0 : this.value)
    : (this.value || null)

  public mounted() {
    this.innerValue = this.selected
    setTimeout(() => {
      this.selected = this.value || null
    }, 100)
  }

  @Watch('selected')
  public onSelected() {
    this.innerValue = this.selected
  }

  @Watch('value')
  public onUpdateValue() {
    this.selected = this.value
  }
}
